
import { Component, Vue, Prop } from 'vue-property-decorator';

import { APP_CONFIG } from '@/config/app-config';

import { PayServiceModel } from '@/models/payservice';
import formatNumber from '@/shared/filters/format-number';

@Component
export default class AmountDetailPayService extends Vue {
    @Prop({default: null})
    private payservice!: PayServiceModel;
    get paytypeList() {
        return [
            { value: 'bank', name: 'Chuyển khoản ngân hàng' },
            { value: 'wechat', name: 'Wechat' },   
            { value: 'alipay', name: 'Alipay' }
        ];
    }
}
